import { Config } from "src/models";
import logo from "src/assets/static/img/main/anten-logo-new.svg";
import shima from "src/assets/static/img/main/anten-logo-shima.svg";
import { DefaultLanguage } from "src/constants";

export type ConfigInit = {
    loading: boolean;
    loaded: boolean;
    config: Config;
};

export const ConfigInitInitialState: ConfigInit = {
    loading: true,
    loaded: false,
    config: {
        appSetting: {
            activeTabs: [],
            googleAnalyticsId: "",
            playReportDuration: 60,
            statReportDuration: 100,
            vast: { enabled: false },
            isPackagingSystemEnabled: true,
            language: DefaultLanguage,
            singleSubscriptionId: undefined,
            devicesProfileEnabled: false,
            favoritesEnabled: false,
            fullNameMaxLength: 25,
            promotion: {
                betweenProgramListDistribute: 0,
                cancelBtn: "",
                icon: "",
                message: "",
                perNumberOfProgram: 0,
                sliderSpeed: "",
                submitBtn: "",
                title: ""
            }
        },
        logos: {
            Landing: logo,
            Program: logo,
            Television: shima,
            Archive: logo,
            Profile: logo,
            Login: logo,
        },
    }
};